import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { DashboardWrapper } from 'src/containers/wrappers';
import { Box, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { themeColors } from 'src/theme';
import { useTenant } from 'src/api/tenant';
import { AboutTab, AdminTab } from './components';

const TenantContainer = () => {
  const { t } = useTranslation();
  const { id: companyId = '' } = useParams();
  const { tenant, isLoading: isTenantLoading, refetch: refetchTenants } = useTenant(+companyId);
  const [tabsValue, setTabsValue] = useState<number>(0);

  const handleTabsChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabsValue(newValue);
  };

  if (!tenant) {
    return null;
  }

  return (
    <DashboardWrapper breadcrumbs={[[`${tenant.title}`]]}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: 'hidden',
          display: 'flex',
        }}
      >
        <Box sx={{ display: 'flex', flexGrow: 1, overflow: 'hidden', flexDirection: 'column' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '32px', mt: 5 }}>
            <Tabs value={tabsValue} onChange={handleTabsChange} variant="scrollable" scrollButtons="auto">
              <Tab
                label={<Box sx={{ position: 'relative' }}> {t('companyPage.aboutCompany')} </Box>}
                sx={{ textTransform: 'none', fontSize: '16px', color: themeColors.grayDark, '&.Mui-selected': { color: 'black' } }}
              />
              <Tab
                label={<Box sx={{ position: 'relative' }}> {t('companyPage.companyAdmin')} </Box>}
                sx={{ textTransform: 'none', fontSize: '16px', color: themeColors.grayDark, '&.Mui-selected': { color: 'black' } }}
              />
            </Tabs>
          </Box>
          {tabsValue === 0 && <AboutTab tenant={tenant} isTenantLoading={isTenantLoading} refetchTenants={refetchTenants} />}
          {tabsValue === 1 && <AdminTab tenant={tenant} />}
        </Box>
      </Box>
    </DashboardWrapper>
  );
};

export default TenantContainer;
